<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="keep && openid" :key="$route.fullPath" />
    </keep-alive>
    <router-view v-if="!keep && openid " :key="$route.fullPath" />
  </div>
</template>

<script>
import mix from "./assets/js/js";
import { user, info } from "./api/profile";
export default {
  name: "App",
  components: {},
  data() {
    return {
      HERF_PATH: "",
      openid: ""
    };
  },
  computed: {
    keep() {
      return "keepAlive" in this.$route.meta;
    }
  },
  created() {
    // localStorage.setItem("id", "iIRnUalet4CPWaWWUyYoLZjHEmaS8F0d");
    this.openid = localStorage.getItem("id") || "";
    // console.log(this.openid, "zzzz");
    if (!this.openid) {
      var code = this.getQueryString("code");
      // console.log(code, "zhewshicode");
      // return;
      const local = window.location.href.substring(
        window.location.href.lastIndexOf("/")
      );
      // console.log(local, "路径");
      if (
        this.$route.path == "/" ||
        this.$route.path == "/message" ||
        this.$route.path == "/popUp" ||
        this.$route.path == "/activity" ||
        this.$route.path == "/yoga" ||
        this.$route.path == "/lease" ||
        this.$route.path == "/build" ||
        this.$route.path == "/my" ||
        this.$route.path == "/poster"
      ) {
        if (code) {
          this.user(code);
        } else {
          window.location.href =
            "https://www.zizhugroup1088.cn/api.php/user/login?url=" +
            encodeURIComponent(local)+'&connect_redirect=1#wechat_redirect';
        }
        // this.iscode(code,local);
      }
    }
  },
  // mounted() {},
  methods: {
    // 获取code
    getQueryString(name) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
      var r = window.location.search.substr(1).match(reg);
      if (r != null) return unescape(r[2]);
      return null;
    },
    user(code) {
      user(code)
        .then(res => {
          // console.log(res, "----------------");
          if (res.error_code == 0) {
            localStorage.setItem("id", res.data);
            this.openid = res.data;
          } else {
            this.$toast(res.msg);
          }
        })
        .catch(error => {
          // console.log(error, "zhangpeilong");
        });
    }
  }
};
</script>

<style>
@import "assets/style/reset.css";
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  height: 100%;
  width: 100%;
  max-width: 45rem;
  margin: 0 auto;
  font-family: "PingFang-SC-Bold";
}
[v-cloak] {
  display: none;
}
.fade-enter,
.fade-leave-active {
  opacity: 0;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
</style>



// WEBPACK FOOTER //
// src/App.vue